export default [
    {   //异步任务列表
        path: "tasks/async",
        name: "tasksAsync",
        component: () => import(/* webpackChunkName: "async" */ "@/views/tasks/asynctask"),
    },
    {   // 库存体积快照
        path: "tasks/inventoryvolume/list",
        name: "inventoryVolume",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/inventoryvolumeshoot/index"),
    },
    {   // 库存体积快照管理端
        path: "tasks/inventoryvolumemanage/list",
        name: "inventoryVolumeManage",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/inventoryvolumeshoot/indexadmin"),
    },
    {   // 客户包仓配置列表
        path: "tasks/customerpackage/list",
        name: "customerPackageList",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/customerpackage/index"),
    },
    {   // 客户包仓配置详情
        path: "tasks/customerpackage/update/:type",
        name: "customerPackageUpdate",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/customerpackage/update"),
    },
    {   // 成本包仓配置列表
        path: "tasks/costpackage/list",
        name: "costPackageList",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/costpackage/index"),
    },
    {   // 成本包仓配置详情
        path: "tasks/costpackage/update/:type",
        name: "costPackageUpdate",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/costpackage/update"),
    },
    {   // 客户报价管理列表
        path: "tasks/customerquotation/list",
        name: "customerQuotationList",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/customerquotation/index"),
    },
    {   // 客户报价管理详情
        path: "tasks/customerquotation/update/:type",
        name: "customerQuotationUpdate",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/customerquotation/update"),
    },
    {   // 成本报价管理列表
        path: "tasks/costquotation/list",
        name: "costQuotationList",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/costquotation/index"),
    },
    {   // 成本报价管理详情
        path: "tasks/costquotation/update/:type",
        name: "costQuotationUpdate",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/tasks/costquotation/update"),
    },
    {   // 计价方案
        path: "tasks/valuation",
        name: "tasksValuation",
        component: () => import(/* webpackChunkName: "async" */ "@/views/tasks/valuation/index"),
    },
    {
        path:'tasks/valuation/update/:type',
        name:'tasksValuationUpdate',
        component: () => import(/* webpackChunkName: "report" */ "@/views/tasks/valuation/update")
    },
    // 报价方案-应收
    {   
        path: "tasks/receiveoffer/list",
        name: "tasksReceiveoffer",
        component: () => import(/* webpackChunkName: "async" */ "@/views/tasks/receiveoffer/index"),
    },
    {
        path:'tasks/receiveoffer/update/:type',
        name:'tasksReceiveofferUpdate',
        component: () => import(/* webpackChunkName: "report" */ "@/views/tasks/receiveoffer/update")
    },
    // 报价方案-应付
    {   
        path: "tasks/payableoffer/list",
        name: "tasksPayableoffer",
        component: () => import(/* webpackChunkName: "async" */ "@/views/tasks/payableoffer/index"),
    },
    {
        path:'tasks/payableoffer/update/:type',
        name:'tasksPayableofferUpdate',
        component: () => import(/* webpackChunkName: "report" */ "@/views/tasks/receiveoffer/update")
    },
]


